import React from 'react';
import './topicContent.scss';

interface ITopicContent {
  contentText?: string;
  type?: 'business' | 'seatrade' | 'economy' | 'politics' | 'esg' | 'culture';
  mainImg?: string;
}

export const TopicContent = ({ type, contentText, mainImg }: ITopicContent) => {
  return (
    <div className="topic-content-block-container">
      <div className={'img-box'}>
        {/* TODO : img를 어드민에서 전달 함 - img 테그 내에서 반응형으로 잡을 수 있는 방법 필요 */}
        <img src={mainImg} alt="each category img" className={`content_img_${type}`} width={'100%'} />
      </div>
      <div className={`topic-content-category ${type}Category`}>{contentText}</div>
    </div>
  );
};
